<template>

  <b-card-code title="Bemerkungen">
    <b-row>
      <b-col
        md="12"
        xl="12"
        class="mb-1"
      >
        <b-form-group
          label="Bemerkung"
        >
          <b-form-input
            ref="Description1"
            @keypress="EnterDescription1($event)"
            v-model="fromStore.Description1"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="12"
        xl="12"
        class="mb-1"
      >
        <b-form-group
          label="Bemerkung2"
        >
          <b-form-input
            ref="Description2"
            @keypress="EnterDescription2($event)"
            v-model="fromStore.Description2"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="12"
        xl="12"
        class="mb-1"
      >
        <b-form-group
          label="Rechnung"
        >
          <b-form-input
            ref="DescriptionInvoice"
            v-model="fromStore.DescriptionInvoice"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="12"
        xl="12"
        class="mb-1"
      >
        <b-form-group
          label="PDF Bermerkung"
        >
          <b-form-input
            ref="DescriptionPdf"
            v-model="fromStore.DescriptionPdf"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BCol, BFormGroup, BFormInput, BRow,
} from 'bootstrap-vue'

export default {
  name: 'Remark',
  components: {
    BCardCode,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  data() {
    return {
      fromStore: {},
      SubmitVoucherWatch: 0,
    }
  },
  created() {
    this.fromStore = this.$store.state.voucher.vData
  },
  methods: {
    SetCursorInput() {
      this.$refs.Description1.$el.select()
    },
    EnterDescription1(event) {
      if (event.which == 13) this.$refs.Description2.$el.select()

    },
    EnterDescription2(event) {
      if (event.which == 13) this.SubmitVoucherWatch = new Date()

    },
  },
}
</script>

<style scoped>

</style>
